import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot,NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  // Define allowed previous routes for each page
  private allowedFlows: { [key: string]: string[] } = {
    welcome: ['register', 'security-question', 'blu', 'wingfield', 'cars-registration', 'register-step-two','onboarding','framer-otp' ],
    income: ['welcome','onboarding'],
    reducedebt: ['income','onboarding'],
    ready: ['reducedebt', 'income','onboarding']
  };


  constructor(private router: Router,private cookieService: CookieService) {   
  }

  public getPreviousUrl(): string | null {
    var previousUrl = localStorage.getItem('PageUrls');
    
    if (!previousUrl) {
      previousUrl = document.referrer
    };
      localStorage.removeItem('PageUrls');
    return previousUrl;
  }
  public getCurrentUrl(): string | null {
    return window.location.href;
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    var previousUrl = this.getPreviousUrl() || '';
    var currentUrl = this.getCurrentUrl() || '';
    const hasToken = !!this.cookieService.get('authToken');
    if (!hasToken || !previousUrl) {
      return false;
    }

    // Find the current page key (e.g., 'welcome', 'income', etc.)
    const currentPage = Object.keys(this.allowedFlows).find(key => currentUrl.includes(key));
    if (currentPage) {
       const isValid = this.allowedFlows[currentPage].some(prev => previousUrl.includes(prev));
      if (!isValid) {
        this.router.navigate(['/login']);
        return false;
      }
      else {
        return true
      }
    }

    return false;
  }
}